export const FETCH_DATAS_REQUEST = 'FETCH_DATAS_REQUEST';
export const FETCH_DATAS_SUCCESS = 'FETCH_DATAS_SUCCESS';
export const FETCH_DATAS_FAILURE = 'FETCH_DATAS_FAILURE';
